(() => {
  const wrapper = document.querySelector('.video-section__mediaWrapper'),
        video = wrapper.querySelector('.video'),
        poster = wrapper.querySelector('.video-section__poster'),
        posterImage = poster.querySelector('.video-section__image');

  function togleVideo() {
    if (video.paused && !video.classList.contains('newTab')) {
      posterImage.classList.add('video-section__image--disabled')
      wrapper.classList.add('video-section__media--played');
      video.play();
    } else {
      wrapper.classList.remove('video-section__media--played');
      video.pause();
    }
  };

  wrapper.addEventListener('click', togleVideo);

  
})();

function checkVideo(video_elm, video_url, mobile_video_url) {
  
  var video = document.querySelector(video_elm + " video");
  var video_source = document.querySelector(video_elm + " video source");
  var wrapper = document.querySelector(video_elm + " .video-section__mediaWrapper");

  if (video_source != null) {
    if (window.innerWidth < 768 && mobile_video_url) {
      if (video_source.getAttribute('src') != mobile_video_url) {
        video_source.setAttribute("src", mobile_video_url);
        video.load();
        if (!video.hasAttribute("autoplay")) {
          wrapper.classList.remove('video-section__media--played');
        }
      }
    }
    else if (video_source.getAttribute('src') != video_url) {
      video_source.setAttribute("src", video_url);
      video.load();
      if (!video.hasAttribute("autoplay")) {  
        wrapper.classList.remove('video-section__media--played');
      }
    }
  }
}

function loadVideo(video_elm, video_url, mobile_video_url) {
  var video = document.querySelector(video_elm);
  var video_source = document.querySelector(video_elm + " source");
  if (video_source != null) {
    if (window.innerWidth < 768 && mobile_video_url) {
      video_source.setAttribute("src", mobile_video_url);
    }
    else {
      video_source.setAttribute("src", video_url);
    }
    video.load();
  }
};